import { useSearchParams } from 'react-router-dom';
import AuditLogTimeline from './AuditLogTimeline';

/**
 * Full audit log page: its filters live in the URL. The host app renders the
 * page header; `onTotalChange(total)` gives it the count for its subtitle.
 */
export default function AuditLogPage({ fetchAuditLogs, onTotalChange }) {
  const [params, setParams] = useSearchParams();

  return (
    <AuditLogTimeline
      width="wide"
      params={params}
      onParamsChange={setParams}
      fetchAuditLogs={fetchAuditLogs}
      onTotalChange={onTotalChange}
      showCount={false}
    />
  );
}
